/*
==========================================================
ACTIVITY STATUS
==========================================================
*/

export const activityStatus = {

  confirmed: {

    label: "Confirmada",

    background: "#DCFCE7",

    color: "#166534"

  },

  pending: {

    label: "Pendiente",

    background: "#FEF3C7",

    color: "#92400E"

  },

  completed: {

    label: "Completada",

    background: "#DBEAFE",

    color: "#1D4ED8"

  },

  cancelled: {

    label: "Cancelada",

    background: "#FEE2E2",

    color: "#B91C1C"

  }

};